module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v("Selecione a quantidade de alunos da escola:")]), _vm._v(" "), _c('range-slider', {
    staticClass: "slider",
    attrs: {
      "min": "25",
      "max": "1025",
      "step": "25"
    },
    model: {
      value: (_vm.form.studentsQuantity),
      callback: function($$v) {
        _vm.$set(_vm.form, "studentsQuantity", $$v)
      },
      expression: "form.studentsQuantity"
    }
  }), _vm._v(" "), (_vm.form.studentsQuantity < 1001) ? _c('span', {
    staticClass: "js-output",
    attrs: {
      "id": "js-output"
    }
  }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm.form.studentsQuantity) + " alunos\n\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.form.studentsQuantity > 1000) ? _c('span', {
    staticClass: "js-output",
    attrs: {
      "id": "js-output"
    }
  }, [_vm._v("\n\t\t\t\tMais de 1.000 alunos\n\t\t\t")]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.sendForm($event)
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Plano: *")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.plan),
      expression: "form.plan"
    }],
    staticClass: "form-control",
    class: {
      'has-error': _vm.errors.has('plan')
    },
    attrs: {
      "name": "plan"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "plan", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "FREE"
    }
  }, [_vm._v("Gratuito")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "BASIC"
    }
  }, [_vm._v("Básico")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "PREMIUM"
    }
  }, [_vm._v("Premium")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Quantidade de Alunos: *")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.studentsQuantity),
      expression: "form.studentsQuantity"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.form.studentsQuantity)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "studentsQuantity", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v("Modalidades de ensino:")]), _vm._v(" "), _c('div', {
    staticClass: "mt-checkbox"
  }, _vm._l((_vm.levelsType), function(value, key) {
    return _c('label', {
      staticClass: "mt-checkbox mt-checkbox-outline"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.form.levels),
        expression: "form.levels"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": key,
        "checked": Array.isArray(_vm.form.levels) ? _vm._i(_vm.form.levels, key) > -1 : (_vm.form.levels)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.form.levels,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = key,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.form, "levels", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.form, "levels", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.form, "levels", $$c)
          }
        }
      }
    }), _vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(value) + "\n\t\t\t\t\t\t\t\t"), _c('span')])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('schoolName')
    }
  }, [_c('label', [_vm._v("Nome da escola: *")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.schoolName),
      expression: "form.schoolName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "schoolName"
    },
    domProps: {
      "value": (_vm.form.schoolName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "schoolName", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('mobilePhoneNumber')
    }
  }, [_c('label', [_vm._v("Telefone celular: *")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: ('(##)#####-####'),
      expression: "'(##)#####-####'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.form.mobilePhoneNumber),
      expression: "form.mobilePhoneNumber"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "num",
      "name": "mobilePhoneNumber"
    },
    domProps: {
      "value": (_vm.form.mobilePhoneNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "mobilePhoneNumber", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('contactName')
    }
  }, [_c('label', [_vm._v("Nome de Contato: *")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.contactName),
      expression: "form.contactName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "contactName"
    },
    domProps: {
      "value": (_vm.form.contactName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "contactName", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('contactEmailAddress')
    }
  }, [_c('label', [_vm._v("E-mail Contato: *")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.contactEmailAddress),
      expression: "form.contactEmailAddress"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "name": "contactEmailAddress"
    },
    domProps: {
      "value": (_vm.form.contactEmailAddress)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "contactEmailAddress", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Voucher de desconto:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.voucherNumber),
      expression: "form.voucherNumber"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.voucherNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "voucherNumber", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-1 pull-right"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('companyName')
    }
  }, [_c('button', {
    staticClass: "btn btn-sucess",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Simular")])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('h2', [_vm._v("Simulador")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-12e6ea25","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./sources/app/simulator/simulator/simulator.vue
// module id = 1035
// module chunks = 1